import { useLayoutEffect, useRef, useState } from 'react'

/**
 * Encapsulates the logic to measure one of the list items to ensure we provide an accurate list item height to react-window
 * Pass the returned ref to the DOM element you wish you measure and check the returned height value for its measurement
 */
export function useHeightMeasurement<ElementType>(initialHeight: number): {
  height?: number
  measurementRef: React.Ref<ElementType>
} {
  const [listItemHeight, setListItemHeight] = useState<number>(initialHeight)
  const listItemRef = useRef(null)

  useLayoutEffect(() => {
    if (listItemRef.current && listItemHeight === initialHeight) {
      const actualHeight = listItemRef.current.offsetHeight

      if (actualHeight !== listItemHeight && actualHeight !== 0) {
        setListItemHeight(actualHeight)
      }
    }
  }, [initialHeight, listItemHeight, setListItemHeight])

  return {
    height: listItemHeight,
    measurementRef: listItemRef
  }
}
